import { axios, classNameGenerator } from "@/utils"
import styles from "./ProsAndVideoSection.module.scss"
import { SVGSprite } from "@/components/Atoms"
import Typography from "@/foundation/Typography/V2"
import { useEffect, useState } from "react"
import YoutubeIframe from "@/components/Organisms/YoutubeIframe"
import dynamic from "next/dynamic";
import ModalMotion, { AnimateDirection } from "@/components/Molecules/ModalMotion"
import { useAppSelector, useWindowDimensions } from "@/hooks"

const VideoOverlay = dynamic(() =>
    import("@/containers/NutritionPackagesPage/NutritionistVideo/VideoOverlay"),
    { ssr: false }
);

const ProsAndVideoSection = () => {
    const cls = classNameGenerator(styles)
    const [thumbnail, setThumbnail] = useState("https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2024-05/ttc-thummbnail-18e7166453274ff5a124a462eec72919.png");
    const [showOverlay, setShowOverlay] = useState(true);
    const [videoId, setVideoId] = useState("");
    const [showVideoFrame, setShowVideoFrame] = useState(false)
    const { width } = useWindowDimensions();
    const isMobile = width < 600

    const { data } = useAppSelector((state) => state.bootCamp);

    if(!data?.ProsAndVideoSection)
      return <></>
    
    const {features, ytUrl,ytThumbnail} = data?.ProsAndVideoSection || {}
    
    const videoUrl = ytUrl
    const thumbnailImage = ytThumbnail

    useEffect(() => {
        if (videoUrl) {
            const youtubeIDParser = (url) => {
                const regExp =
                    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                const match = url.match(regExp);
                return match && match[7].length === 11 ? match[7] : false;
            };

            const _videoId = youtubeIDParser(videoUrl);
            setVideoId(_videoId);
            if (!thumbnailImage) {
                const url = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${_videoId}&format=json`;
                axios.get(url).then((res) => {
                    setThumbnail(res?.thumbnail_url);
                });
            }
        }
    }, [videoUrl, thumbnailImage]);

    return (
        <section id="ProsAndVideoSection" className={cls("ProsAndVideoSection")}>
            <div className={cls("advantageContainer")}>
                <div className={cls("advantageWrapper")}>
                    <div className={cls("videoContainer")}>
                        <VideoOverlay
                            showLottie={true}
                            thumbnail={thumbnail}
                            onCLickHandler={() => setShowVideoFrame(true)}
                        />
                    </div>
                    <div className={cls("advantages")}>
                        {features.map((_val) => {
                            return (
                                <div className={cls("cardBox")}>
                                    <SVGSprite
                                        icon={_val?.icon}
                                        className={cls("icon")}
                                    />
                                    <Typography
                                        className={cls("title")}
                                        variant="heading1"
                                        dangerouslySetInnerHTML={{ __html: _val?.title }}
                                    />
                                    <Typography
                                        className={cls("subTitle")}
                                        variant="paragraph2"
                                        dangerouslySetInnerHTML={{ __html: _val?.subHeading }}
                                    />
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            {showVideoFrame ? (
                <ModalMotion
                    height="auto"
                    overlayClosable={true}
                    onClose={() => setShowVideoFrame(false)}
                    width="90%"
                    animateDirection={AnimateDirection.CENTER}
                    borderRadius="16px"
                    className={cls("iframeModal")}
                    bodyPadding="0px"
                    bodyBorderRadius={isMobile? "8px":"16px"}
                >
                    <YoutubeIframe
                        videoId={videoId}
                        showControls={true}
                        callBack={() => setShowOverlay(true)}
                    />
                </ModalMotion>
            ) : (
                <></>
            )}
        </section>
    )
}

export default ProsAndVideoSection